import './_nav.js';


var fromTop = 200;

( function( $ ) {

   function scrolled () {
      if ( ( $(window).scrollTop() - $('body').offset().top ) > fromTop ) {
         $('body').addClass("scrolled");
      } else {
         $('body').removeClass("scrolled");
      }
   }


   $(window).on("resize scroll", function () {
      scrolled();
   });



} )( jQuery );

// Dein Haupt-Code
document.addEventListener('DOMContentLoaded', function() {
   console.log('Theme JS geladen');

   // Initialisiere deine Komponenten hier
});
